import {
    AfterViewInit,
    Component,
    Inject,
    Optional,
    OnInit,
    ViewChild,
    Input,
    Output,
    EventEmitter,
} from '@angular/core';
import {
    MatDialog,
    MatDialogRef,
    MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatTable } from '@angular/material/table';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TranslateService } from '@ngx-translate/core';
import { MatCalendar } from '@angular/material/datepicker';
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MatDateFormats,
} from '@angular/material/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
    FormBuilder,
    FormGroup,
    FormControl,
    Validators,
} from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { SujetoObligado } from 'app/main/models/sujeto-obligado.model';
import { TipoSujetoObligadoService } from 'app/main/services/tipo-sujeto-obligado.service';
import { TipoDocumentoService } from 'app/main/services/tipo-documento.service';
import { PaisService } from 'app/main/services/pais.service';
import { SectorActividadService } from 'app/main/services/sector-actividad.service';
import { ProfesionService } from 'app/main/services/profesion.service';
import { PersonaFisica } from 'app/main/models/persona-fisica.model';
import { PersonaJuridica } from 'app/main/models/persona-juridica.model';
import { Contacto } from 'app/main/models/contacto.model';
import { MonedaService } from 'app/main/services/moneda.service';
import { TipoOperacionService } from 'app/main/services/tipo-operacion.service';
import { MarcoDeReferenciaService } from 'app/main/services/marco-de-referencia.service';
import { Formulario } from 'app/main/models/formulario.model';
import {
    MatTreeFlatDataSource,
    MatTreeFlattener,
} from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { FormularioItem } from 'app/main/models/formulario-item.model';
import { FormularioService } from 'app/main/services/formulario.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilsService } from 'app/main/services/utils.service';
import { Cliente } from 'app/main/models/cliente.model';
import { DecimalPipe } from '@angular/common';
import { DebidaDiligenciaService } from 'app/main/services/debida-diligencia.service';
import {DialogBoxTreeComponent} from './dialog-box-tree.component';

interface ExampleFlatNode {
    expandable: boolean;
    name: string;
    level: number;
}

@Component({
    selector: 'app-dialog-box-debida-diligencia-nuevo-formulario',
    templateUrl: './dialog-box-debida-diligencia-nuevo-formulario.component.html',
    styleUrls: ['./dialog-box-debida-diligencia-nuevo-formulario.component.scss'],
    providers: [DecimalPipe],
})
export class DialogBoxDebidaDiligenciaNuevoFormularioComponent {

    constructor(
        public dialogRef: MatDialogRef<DialogBoxDebidaDiligenciaNuevoFormularioComponent>,
        public translate: TranslateService,
        public dialog: MatDialog,
        private _formBuilder: FormBuilder,
        private serviceTipoSujetoObligado: TipoSujetoObligadoService,
        private serviceTipoDocumento: TipoDocumentoService,
        private servicePais: PaisService,
        private serviceSectorIndustrial: SectorActividadService,
        private serviceProfesion: ProfesionService,
        private serviceMoneda: MonedaService,
        private serviceTiposOperacion: TipoOperacionService,
        private serviceMarcoDeReferencia: MarcoDeReferenciaService,
        private service: FormularioService,
        private serviceDD: DebidaDiligenciaService,
        public utils: UtilsService,
        private _snackBar: MatSnackBar,
        private decimalPipe: DecimalPipe,

        // @Optional() is used to prevent error if no data is passed
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.LOCAL_DATA = { ...data };

        if (this.LOCAL_DATA.destinatarios == null) {
            this.LOCAL_DATA.destinatarios = [];
        }
        this.action = data.action;

        this.service
            .getAll(0, 1000)
            .pipe()
            .subscribe((req) => {
                this.formularios = req.body.map((tipo) => {
                    console.log(tipo);
                    return {
                        id: tipo.id,
                        nombre: tipo.nombre,
                    };
                });
            });

    }
    // @Output() eventoDesdePadre: EventEmitter<any> = new EventEmitter<any>();
    @Output() eventoDesdePadre: string;

    private _transformer = (node: FormularioItem, level: number) => {
        return {
            expandable: !!node.sentencias && node.sentencias.length > 0,
            name: node.nombre,
            level: level,
            descripcion: node.descripcion,
        };
    }

    action: string;
    LOCAL_DATA: any;
    GENERAL_DATA: SujetoObligado = new SujetoObligado({});
    visible = true;
    removable = true;
    addOnBlur = true;

    // Estructura para el formulario
    isFormLoaded = false;
    treeControl = new FlatTreeControl<ExampleFlatNode>(
        (node) => node.level,
        (node) => node.expandable
    );

    treeFlattener = new MatTreeFlattener(
        this._transformer,
        (node) => node.level,
        (node) => node.expandable,
        (node) => node.sentencias
    );

    dataSource = new MatTreeFlatDataSource(
        this.treeControl,
        this.treeFlattener
    );

    razonSocialPais = null;
    tiposDocumentos = [];
    tiposSujetos = [];
    tiposSectorIndustrial = [];
    tiposProfesiones = [];
    paises = [];
    monedas = [];
    tiposDeOperacion = [];
    formularios = [];
    showNewClient = false;

    doAction(): void {
        this.dialogRef.close({ event: this.action, data: this.LOCAL_DATA });
    }

    closeDialog(): void {
        this.dialogRef.close({ event: 'Cancel' });
    }


    /// ESTRUCTURA PARA MANEJAR LOS FORMULARIOS

    setFormulario() {
        if (this.LOCAL_DATA.formulario.id != null) {
            this.service
                .get(this.LOCAL_DATA.formulario.id)
                .pipe()
                .subscribe((req) => {
                    this.LOCAL_DATA.formulario = new Formulario(req.body);
                    // this.dataSourceList = data.dataSource;
                    this.orderStructure(this.LOCAL_DATA.formulario.sentencias);
                    this.dataSource.data = [
                        ...this.LOCAL_DATA.formulario.sentencias,
                    ];
                    this.isFormLoaded = true;
                });
        } else {
            this.isFormLoaded = true;
        }
    }

    hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

    ngOnInit(): void {}

    openDialog(action, obj): void {
        obj.action = action;
        obj.info = this.LOCAL_DATA.formulario;
        const dialogRef = this.dialog.open(DialogBoxTreeComponent, {
            width: '100%',
            data: obj,
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result.event === 'Modifier') {
                this.ngOnInit();
            } else if (result.event !== 'Cancel') {
                this.LOCAL_DATA.formulario.sentencias = [...result.data];
                this.dataSource.data = [
                    ...this.LOCAL_DATA.formulario.sentencias,
                ];
            } else {
                this.LOCAL_DATA.formulario.sentencias = [...result.data];
            }
        });
    }


    orderStructure(sentencias): void {
        if (sentencias != null) {
            for (let z = 0; sentencias.length > z; z++) {
                sentencias.sort(this.utils.sortAlphaNum);
                // sentencias.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
                this.orderStructure(sentencias[z].sentencias);
            }
        }
    }

    compareObjects(o1: any, o2: any): boolean {
        let equals = false;
        if (o1 != null && o2 != null) {
            equals = o1.nombre === o2.nombre && o1.id === o2.id;
        }
        return equals;
    }
}
